import React, { useEffect, useState } from "react";
import { db, collection, onSnapshot } from "../boardData";
import { WidgetShell, EmptyState } from "./common";

function toDate(v) {
  if (!v) return null;
  if (typeof v.toDate === "function") return v.toDate();
  if (typeof v.seconds === "number") return new Date(v.seconds * 1000);
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

// Expiring certifications across Agencies/{agency}/Personnel. Defensive about the
// per-person certification shape (array of {name, expiration|expires|expirationDate}).
const TrainingCertsWidget = ({ config = {}, agency }) => {
  const [rows, setRows] = useState([]);
  const withinDays = config.expiringWithinDays || 60;

  useEffect(() => {
    if (!agency) return undefined;
    const unsub = onSnapshot(
      collection(db, "Agencies", agency, "Personnel"),
      (snap) => {
        const now = Date.now();
        const horizon = now + withinDays * 24 * 60 * 60 * 1000;
        const out = [];
        snap.docs.forEach((d) => {
          const p = d.data();
          const name = p.name || [p.firstName, p.lastName].filter(Boolean).join(" ") || d.id;
          const certs = Array.isArray(p.certifications) ? p.certifications : [];
          certs.forEach((c) => {
            const exp = toDate(c.expiration || c.expires || c.expirationDate || c.expiryDate);
            if (exp && exp.getTime() <= horizon) {
              out.push({ name, cert: c.name || c.title || c.type || "Certification", exp });
            }
          });
        });
        out.sort((a, b) => a.exp - b.exp);
        setRows(out.slice(0, 30));
      },
      (err) => console.warn("training certs load failed", err)
    );
    return () => unsub();
  }, [agency, withinDays]);

  return (
    <WidgetShell title={`Expiring Certifications (${withinDays}d)`}>
      {rows.length === 0 ? (
        <EmptyState icon="🎓" label="No certifications expiring soon." />
      ) : (
        <div className="sb-cert-list">
          {rows.map((r, i) => {
            const days = Math.ceil((r.exp - Date.now()) / (24 * 60 * 60 * 1000));
            return (
              <div className={`sb-cert ${days < 0 ? "expired" : days <= 14 ? "soon" : ""}`} key={i}>
                <span className="sb-cert-name">{r.name}</span>
                <span className="sb-cert-cert">{r.cert}</span>
                <span className="sb-cert-exp">
                  {days < 0 ? "Expired" : `${days}d`} · {r.exp.toLocaleDateString()}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </WidgetShell>
  );
};

export default TrainingCertsWidget;
